import { combineReducers } from "redux";
import entityReducer from "./entityReducers";
import uiReducer from "./uiReducers";
import { ErrorReduxState } from "./uiReducers/errorReducer";
import { DatasourceDataState } from "./entityReducers/datasourceReducer";
import { ApplicationsReduxState } from "./uiReducers/applicationsReducer";
import { PageListReduxState } from "./entityReducers/pageListReducer";
import { AuthState } from "reducers/uiReducers/authReducer";
import { OrgReduxState } from "reducers/uiReducers/orgReducer";
import { UsersReduxState } from "reducers/uiReducers/usersReducer";
import { ThemeState } from "reducers/uiReducers/themeReducer";
import { AppDataState } from "reducers/entityReducers/appReducer";
import { createReducer } from "../utils/AppsmithUtils";
import { ReduxActionTypes } from "../constants/ReduxActionConstants";

const initialState: any = {};

const layoutReducer = createReducer(initialState, {
  [ReduxActionTypes.SET_LAYOUT_ITEM]: (state: any, action: any) =>
    action.payload,
});
const layoutUpdateReducer = createReducer(initialState, {
  [ReduxActionTypes.UPDATE_LAYOUT_ITEM]: (state: any, action: any) =>
    action.payload,
});
const layoutRemoveReducer = createReducer(initialState, {
  [ReduxActionTypes.REMOVE_LAYOUT_ITEM]: (state: any, action: any) =>
    action.payload,
});
const layout = combineReducers({
  dockLayoutItem: layoutReducer,
  dockLayoutUpdateItem: layoutUpdateReducer,
  dockLayoutRemoveItem: layoutRemoveReducer,
});

const appReducer = combineReducers({
  entities: entityReducer,
  ui: uiReducer,
  layout: layout,
});

export default appReducer;

export interface AppState {
  ui: {
    errors: ErrorReduxState;
    applications: ApplicationsReduxState;
    auth: AuthState;
    orgs: OrgReduxState;
    users: UsersReduxState;
    theme: ThemeState;
  };
  entities: {
    datasources: DatasourceDataState;
    pageList: PageListReduxState;
    app: AppDataState;
  };
  layout: any;
}
